export enum TestValidationStatus {
  Valid = 'valid',
  Invalid = 'invalid',
}
